
import { Component } from 'react'
import Post from '../../src/components/post'
import ComponentTree from '../../src/components/component-tree'
import components from '../../src/components/md-components'

export default (props) => {
  const data = {
  "layout": "post",
  "title": "Images from the Brooklyn Bridge",
  "date": "2014-08-29 18",
  "comments": "true",
  "categories": "[\"photo\", \"summer\"]",
  "path": "pages/posts/undefined.js",
  "permalink": "posts/undefined",
  "created": "2014-08-29",
  "tags": [
    "photo",
    "summer"
  ],
  "draft": false
}
  const body = {"type":"div","props":{},"children":[{"type":"p","props":{},"children":["We spent some time in New York City today to kickoff the long weekend. It was mostly a day of bouncing around lower Manhattan, but eventually we needed to make it over to Brooklyn to catch up with my brother and thought it would be fun to walk the Brooklyn Bridge on our way. It turned out to be the very best of golden hours, which made the stroll particularly photogenic."]},"\n",{"type":"p","props":{},"children":["The x100s was set at f/4 for all of these. I had the shutter speed higher than I usually might (~1/1000, resulting in ISO jumping to 400/800) since there was so much movement going on.\n",{"type":"img","props":{"src":"/static/images/posts/2014-08-29-bridge/DSCF5581.jpg","alt":"bridge1"}},"\n",{"type":"img","props":{"src":"/static/images/posts/2014-08-29-bridge/DSCF5586.jpg","alt":"batman"}},"\n",{"type":"img","props":{"src":"/static/images/posts/2014-08-29-bridge/DSCF5587.jpg","alt":"photog"}},"\n",{"type":"img","props":{"src":"/static/images/posts/2014-08-29-bridge/DSCF5588.jpg","alt":"blonde"}}]}]}
  return (
    <Post {...data}>
      <ComponentTree {...body} components={components} />
    </Post>
  )
}
